import(/* webpackMode: "eager" */ "/vercel/path0/apps/bullmq-admin/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/bullmq-admin/src/components/Providers/JotaiProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/bullmq-admin/src/components/Providers/next-auth/NextAuthClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/bullmq-admin/src/components/Providers/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetI18nFromUserPreferences"] */ "/vercel/path0/apps/bullmq-admin/src/components/Providers/SetI18nFromUserPreferences.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionLazy"] */ "/vercel/path0/libs/shared/core/ui/animate/src/animate/motion-lazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/shared/core/ui/components/src/mui-license/MuiLicense.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/shared/core/ui/components/src/mui-modal-provider/MuiModalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar"] */ "/vercel/path0/libs/shared/core/ui/components/src/progress-bar/progress-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactToastifyComponent"] */ "/vercel/path0/libs/shared/core/ui/components/src/toast/ToastComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/vercel/path0/libs/shared/locales/src/locales/i18n-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizationProvider"] */ "/vercel/path0/libs/shared/locales/src/locales/localization-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/shared/theme/feature/src/settings/context/settings-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/shared/theme/feature/src/settings/context/use-settings-context.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/shared/theme/feature/src/settings/drawer/settings-drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/libs/shared/theme/feature/src/theme/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryDevtools"] */ "/vercel/path0/node_modules/@tanstack/react-query-devtools/build/modern/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
